import EventEmitter from 'events';
import ZoneSelector from './ZoneSelector';
import dom from '../../../utils/dom';

const MULTI_ZONE_SEPARATOR = '-';

class ZoneSelectorCollection extends EventEmitter {
  /**
   * @param {HTMLElement} container
   */
  constructor(container) {
    super();
    const zoneSelectorContainers = dom.findAllFrom(container, '.tn-ticket-selector__zone-selector');
    const groupSelectorContainers = dom.findAllFrom(container, '.tn-ticket-selector__zone-group-selector');

    this.zoneSelectors = zoneSelectorContainers.map((el, index) => {
      const zoneSelector = new ZoneSelector(el, groupSelectorContainers[index]);

      zoneSelector.on('update', this.onZoneUpdate);

      return zoneSelector;
    });
  }

  onZoneUpdate = () => {
    this.emit('update', this.getSelectedZoneId());
  }

  getSelectedZoneId() {
    const ids = this.zoneSelectors.map(zoneSelector => zoneSelector.getSelectedZoneId());

    return formatIds(ids);
  }

  getSelectedZoneGroupId() {
    const ids = this.zoneSelectors.map(zoneSelector => zoneSelector.getSelectedZoneGroupId());

    return formatIds(ids);
  }

  destroy() {
    this.removeAllListeners();

    this.zoneSelectors.forEach(zoneSelector => zoneSelector.destroy());
  }

  /**
   * @param {string} zoneId
   */
  selectZone(zoneId) {
    let zoneIds = zoneId.split(MULTI_ZONE_SEPARATOR);

    if (zoneIds.length !== this.zoneSelectors.length) {
      zoneIds = Array(this.zoneSelectors.length).fill('');
    }

    zoneIds.forEach((id, index) =>
      this.zoneSelectors[index].selectZone(id));
  }

  autoSelectSingleZone() {
    this.zoneSelectors.forEach(zoneSelector => zoneSelector.autoSelectSingleZone());
  }
}


/**
 * @param {string[]} ids
 */
function formatIds(ids) {
  if (ids.length === 1) {
    return ids[0];
  }

  if (ids.some(id => !id)) {
    return '';
  }

  return ids.join(MULTI_ZONE_SEPARATOR);
}


export default ZoneSelectorCollection;
